import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { AppState } from '../../../state/appState';
import { Observable } from 'rxjs';
import { GatewayConfigModel } from '../../services/gateway-config/gatewayConfig.model';

@Component({
  selector: 'app-password-security',
  templateUrl: './password-security.component.html',
  styleUrls: ['./password-security.component.scss'],
})
export class PasswordSecurityComponent {
  @Select(AppState.gatewayConfig$)
  gatewayConfig$: Observable<GatewayConfigModel>;

  @Input('password') set setPassword(p: string) {
    this.password = p;
    this.checkPassword();
  }

  public categories = 0;
  public password = '';

  constructor() {}

  private checkPassword(): void {
    let categories = 0;

    if (this.password.match(/[A-Z]/g)) {
      categories++;
    }
    if (this.password.match(/[a-z]/g)) {
      categories++;
    }
    if (this.password.match(/[\d]/g)) {
      categories++;
    }
    if (this.password.match(/[\W]/g)) {
      categories++;
    }

    this.categories = categories;
  }
}
